<div class="unavailability-layout">
  <div class="schedule-panel">

    <div *ngIf="hasAvailabilityTogglePermission" class="availability-header">
      <span class="availability-label">Available</span>
      <mat-slide-toggle [checked]="(availability$ | async)!" (change)="toggleUserAvailability($event)" color="primary"></mat-slide-toggle>
    </div>

    <form [formGroup]="scheduleForm">
      <div formArrayName="schedules">
        <ng-container *ngFor="let group of schedules.controls; let i = index">
          <div
            *ngIf="group.get('isActive')?.value !== false"
            [formGroupName]="i"
            class="unavailability-row"
          >
            <!-- Delete -->
            <button mat-icon-button (click)="removeSchedule(i)">
              <mat-icon color="warn" style="margin-top: -12px;">delete</mat-icon>
            </button>

            <!-- Unavailable From -->
            <div class="date-cell">
              <label>Unavailable From</label>
              <div class="date-display">
                <span class="date-text" [matTooltip]="group.get('startTime')?.value | date:'short'">
                  {{ group.get('startTime')?.value | date: 'MM/dd hh:mm a' }}
                  <ng-container *ngIf="group.get('startTime')?.value"> CST</ng-container>
                </span>
                <input
                  matInput
                  [ngxMatDatetimePicker]="startDatePicker"
                  (dateChange)="onDateChanged('start', i, $event.value)"
                  [formControl]="group.get('startTime')"
                  [min]="getMinimum(group)"
                  required
                  style="opacity: 0; height: 10; width: 0; position: absolute; pointer-events: none;"
                />                
                <ngx-mat-datetime-picker
                  #startDatePicker
                  [enableMeridian]="true"
                  [showSpinners]="true"
                  [defaultTime]="defaultTime"
                  [stepHour]="1"
                  [stepMinute]="5"
                  [hideTime]="hideTime">
                  <ngx-mat-datepicker-actions>
                    <div>
                      <button mat-button ngxMatDatepickerCancel>Cancel</button>
                      <button mat-raised-button color="primary" ngxMatDatepickerApply>Apply</button>
                    </div>
                  </ngx-mat-datepicker-actions>
                </ngx-mat-datetime-picker>
                <button mat-icon-button (click)="startDatePicker.open()" tabindex="-1">
                  <mat-icon>today</mat-icon>
                </button>
              </div>             
              <mat-error *ngIf="group.get('startTime')?.hasError('required')">
                Start time is required.
              </mat-error>
              <mat-error *ngIf="group.get('startTime')?.hasError('pastDateTime') && group.get('startTime')?.touched">
                Time cannot be in the past.
              </mat-error>
            </div>

            <!-- Unavailable To -->
            <div class="date-cell">
              <label>Unavailable To</label>
              <div class="date-display">
                <span class="date-text" [matTooltip]="group.get('endTime')?.value | date:'short'">
                  {{ group.get('endTime')?.value | date: 'MM/dd hh:mm a' }}
                  <ng-container *ngIf="group.get('endTime')?.value"> CST</ng-container>
                </span>
                <input
                  matInput
                  [ngxMatDatetimePicker]="endPicker"
                  (dateChange)="onDateChanged('end', i, $event.value)"
                  [formControl]="group.get('endTime')"
                  [min]="group.get('startTime')?.value"
                  required
                  style="opacity: 0; height: 10; width: 0; position: absolute; pointer-events: none;"
                />                
                <ngx-mat-datetime-picker
                  #endPicker
                  [enableMeridian]="true"
                  [showSpinners]="true"
                  [defaultTime]="defaultTime"
                  [stepHour]="1"
                  [stepMinute]="5"
                  [hideTime]="hideTime">
                  <ngx-mat-datepicker-actions>
                    <div>
                      <button mat-button ngxMatDatepickerCancel>Cancel</button>
                      <button mat-raised-button color="primary" ngxMatDatepickerApply>Apply</button>
                    </div>
                  </ngx-mat-datepicker-actions>
                </ngx-mat-datetime-picker>
                <button mat-icon-button (click)="endPicker.open()" tabindex="-1">
                  <mat-icon>today</mat-icon>
                </button>
              </div>
              <mat-error *ngIf="group.get('endTime')?.hasError('required')">
                End time is required.
              </mat-error>
              <mat-error *ngIf="group.get('endTime')?.hasError('endBeforeStart') && group.get('endTime')?.touched">
                  End time must be after start time
              </mat-error>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="schedule-actions">
        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="addSchedule(null)"
          class="add-schedule-btn"
        >
        <mat-icon>add</mat-icon> ADD
        </button>
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="saveSchedule()"
          class="add-schedule-btn"
          [disabled]="scheduleForm.invalid || !scheduleForm.dirty"
        >
          <mat-icon>save</mat-icon>
          {{ 'Save Schedules' }}
        </button>
      </div>
    </form>
  </div> 

  <div class="calendar-panel">
    <app-calendar-view [schedules]="schedules"></app-calendar-view>
  </div>
</div>
